import { render } from "./TopFooter.vue?vue&type=template&id=8fc6d976&scoped=true"
import script from "./TopFooter.vue?vue&type=script&lang=js"
export * from "./TopFooter.vue?vue&type=script&lang=js"

import "./TopFooter.vue?vue&type=style&index=0&id=8fc6d976&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc6d976"]])

export default __exports__